var _g, _g2, _g3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErorrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 248,
    viewBox: "0 0 249 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_b_1976_46609)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.566406,
    y: 0.0878906,
    width: 247.863,
    height: 247.863,
    rx: 123.932,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.06641,
    y: 0.587891,
    width: 246.863,
    height: 246.863,
    rx: 123.432,
    stroke: "#E9E9E9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter1_b_1976_46609)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.8223,
    y: 15.3447,
    width: 217.349,
    height: 217.349,
    rx: 108.674,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3223,
    y: 15.8447,
    width: 216.349,
    height: 216.349,
    rx: 108.174,
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter2_b_1976_46609)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.082,
    y: 30.6035,
    width: 186.833,
    height: 186.833,
    rx: 93.4163,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.582,
    y: 32.1035,
    width: 183.833,
    height: 183.833,
    rx: 91.9163,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0674 79.916C73.2393 78.4746 70.585 78.8086 69.1436 80.6367C67.7022 82.4649 68.0361 85.1192 69.8643 86.5606L173.927 168.123C175.755 169.564 178.409 169.23 179.851 167.402C181.292 165.574 180.958 162.92 179.13 161.479L163.872 149.525V123.422C163.169 123.598 162.466 123.738 161.71 123.826H161.692C160.761 123.949 159.811 124.02 158.845 124.02C156.665 124.02 154.573 123.686 152.622 123.088V140.701L121.192 116.057C122.423 115.283 123.53 114.352 124.497 113.297C127.292 116.391 131.37 118.395 135.958 118.395C140.563 118.395 144.624 116.391 147.419 113.297C150.231 116.391 154.292 118.395 158.88 118.395C159.601 118.395 160.304 118.342 161.007 118.254C170.763 116.953 175.386 105.51 170.165 97.2656L160.058 81.3223C159.161 79.8984 157.561 79.0195 155.856 79.0195H93.1377C91.4326 79.0195 89.833 79.8984 88.9365 81.3223L84.9463 87.6504L75.0674 79.916ZM87.9697 118.254C88.6729 118.342 89.3936 118.395 90.0967 118.395C92.0303 118.395 93.8584 118.043 95.5459 117.41L76.8428 102.662C75.7705 109.799 80.2705 117.217 87.9697 118.254ZM96.3721 146.52V123.07C94.4033 123.686 92.2939 124.02 90.1143 124.02C89.1475 124.02 88.1807 123.949 87.249 123.826H87.2314C86.5107 123.721 85.8076 123.598 85.1221 123.422V157.77C85.1221 163.975 90.167 169.02 96.3721 169.02H152.622C154.89 169.02 156.981 168.352 158.757 167.209L132.495 146.52H96.3721Z",
    stroke: "#0E2B3A",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.199 99.1855V101.471H105.631V99.1855H113.199ZM106.588 87.252V101.471H103.658V87.252H106.588ZM112.213 93.043V95.2695H105.631V93.043H112.213ZM113.189 87.252V89.5469H105.631V87.252H113.189ZM117.545 93.209V101.471H114.732V90.9043H117.379L117.545 93.209ZM120.729 90.8359L120.68 93.4434C120.543 93.4238 120.377 93.4076 120.182 93.3945C119.993 93.375 119.82 93.3652 119.664 93.3652C119.267 93.3652 118.922 93.4173 118.629 93.5215C118.342 93.6191 118.102 93.7656 117.906 93.9609C117.717 94.1562 117.574 94.3939 117.477 94.6738C117.385 94.9538 117.333 95.2728 117.32 95.6309L116.754 95.4551C116.754 94.7715 116.822 94.1432 116.959 93.5703C117.096 92.9909 117.294 92.4863 117.555 92.0566C117.822 91.627 118.147 91.2949 118.531 91.0605C118.915 90.8262 119.355 90.709 119.85 90.709C120.006 90.709 120.165 90.722 120.328 90.748C120.491 90.7676 120.624 90.7969 120.729 90.8359ZM124.869 93.209V101.471H122.057V90.9043H124.703L124.869 93.209ZM128.053 90.8359L128.004 93.4434C127.867 93.4238 127.701 93.4076 127.506 93.3945C127.317 93.375 127.145 93.3652 126.988 93.3652C126.591 93.3652 126.246 93.4173 125.953 93.5215C125.667 93.6191 125.426 93.7656 125.23 93.9609C125.042 94.1562 124.898 94.3939 124.801 94.6738C124.71 94.9538 124.658 95.2728 124.645 95.6309L124.078 95.4551C124.078 94.7715 124.146 94.1432 124.283 93.5703C124.42 92.9909 124.618 92.4863 124.879 92.0566C125.146 91.627 125.471 91.2949 125.855 91.0605C126.24 90.8262 126.679 90.709 127.174 90.709C127.33 90.709 127.49 90.722 127.652 90.748C127.815 90.7676 127.949 90.7969 128.053 90.8359ZM128.639 96.2949V96.0898C128.639 95.3151 128.749 94.6022 128.971 93.9512C129.192 93.2936 129.514 92.724 129.938 92.2422C130.361 91.7604 130.882 91.3861 131.5 91.1191C132.118 90.8457 132.828 90.709 133.629 90.709C134.43 90.709 135.143 90.8457 135.768 91.1191C136.393 91.3861 136.917 91.7604 137.34 92.2422C137.77 92.724 138.095 93.2936 138.316 93.9512C138.538 94.6022 138.648 95.3151 138.648 96.0898V96.2949C138.648 97.0632 138.538 97.776 138.316 98.4336C138.095 99.0846 137.77 99.6543 137.34 100.143C136.917 100.624 136.396 100.999 135.777 101.266C135.159 101.533 134.449 101.666 133.648 101.666C132.848 101.666 132.135 101.533 131.51 101.266C130.891 100.999 130.367 100.624 129.938 100.143C129.514 99.6543 129.192 99.0846 128.971 98.4336C128.749 97.776 128.639 97.0632 128.639 96.2949ZM131.451 96.0898V96.2949C131.451 96.7376 131.49 97.151 131.568 97.5352C131.646 97.9193 131.77 98.2578 131.939 98.5508C132.115 98.8372 132.343 99.0618 132.623 99.2246C132.903 99.3874 133.245 99.4688 133.648 99.4688C134.039 99.4688 134.374 99.3874 134.654 99.2246C134.934 99.0618 135.159 98.8372 135.328 98.5508C135.497 98.2578 135.621 97.9193 135.699 97.5352C135.784 97.151 135.826 96.7376 135.826 96.2949V96.0898C135.826 95.6602 135.784 95.2565 135.699 94.8789C135.621 94.4948 135.494 94.1562 135.318 93.8633C135.149 93.5638 134.924 93.3294 134.645 93.1602C134.365 92.9909 134.026 92.9062 133.629 92.9062C133.232 92.9062 132.893 92.9909 132.613 93.1602C132.34 93.3294 132.115 93.5638 131.939 93.8633C131.77 94.1562 131.646 94.4948 131.568 94.8789C131.49 95.2565 131.451 95.6602 131.451 96.0898ZM143.189 93.209V101.471H140.377V90.9043H143.023L143.189 93.209ZM146.373 90.8359L146.324 93.4434C146.188 93.4238 146.021 93.4076 145.826 93.3945C145.637 93.375 145.465 93.3652 145.309 93.3652C144.911 93.3652 144.566 93.4173 144.273 93.5215C143.987 93.6191 143.746 93.7656 143.551 93.9609C143.362 94.1562 143.219 94.3939 143.121 94.6738C143.03 94.9538 142.978 95.2728 142.965 95.6309L142.398 95.4551C142.398 94.7715 142.467 94.1432 142.604 93.5703C142.74 92.9909 142.939 92.4863 143.199 92.0566C143.466 91.627 143.792 91.2949 144.176 91.0605C144.56 90.8262 144.999 90.709 145.494 90.709C145.65 90.709 145.81 90.722 145.973 90.748C146.135 90.7676 146.269 90.7969 146.373 90.8359Z",
    fill: "#0E2B3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9023 113.386L78.127 106.404L78.8129 104.991L92.5351 115.888L92.1315 117.382H86.1583L79.9023 113.386Z",
    fill: "#0E2B3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1976_46609",
    x: -69.4336,
    y: -69.9121,
    width: 387.863,
    height: 387.863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1976_46609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1976_46609",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1976_46609",
    x: -54.1777,
    y: -54.6553,
    width: 357.35,
    height: 357.349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1976_46609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1976_46609",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_1976_46609",
    x: -38.918,
    y: -39.3965,
    width: 326.832,
    height: 326.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1976_46609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1976_46609",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErorrLogo);
export default __webpack_public_path__ + "static/media/ErorrLogo.ae2cf067a1f5db109495142a12025d5d.svg";
export { ForwardRef as ReactComponent };